import { useInfiniteQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { EngineListQuery } from '@rossum/api-client/engines';
import { api } from '../../../lib/apiClient';
import { resolveNextPageParam } from '../../../lib/resolveNextPageParam';
import { engineKeys } from '../keys';

export const useInfiniteEngines = (query: EngineListQuery) =>
  useInfiniteQuery({
    queryKey: engineKeys.list({ filters: query }),
    queryFn: ({ pageParam = 1 }) =>
      api.request(
        endpoints.engines.list({
          ...query,
          page: pageParam,
        })
      ),
    getNextPageParam: resolveNextPageParam,
  });
